import { render, staticRenderFns } from "./weeks.vue?vue&type=template&id=d2a3f71a&scoped=true&"
import script from "./weeks.vue?vue&type=script&lang=js&"
export * from "./weeks.vue?vue&type=script&lang=js&"
import style0 from "./weeks.vue?vue&type=style&index=0&id=d2a3f71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a3f71a",
  null
  
)

export default component.exports